import { useFormikContext } from "formik"
import { Typography } from "@mui/material"
import { CreateOrEditShopFormValues } from "../../shopsTypes"
import { useMerchant } from "../../../../../merchants/merchantHooks"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { AccordionContent, CustomCheckboxAccordion } from "./CustomCheckboxAccordion"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PaymentMethodsResponse, ShopsQuery, paymentMethodsList } from "../../shopsApi"
import { getPaymentMethodType } from "../../../../../receipt/components/PurchaseDetailsSection"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"

const selectShops = (data: PaymentMethodsResponse) => data?.paymentMethods || []

export const SelectPaymentDetails = () => {
    const { merchantId } = useMerchant()
    const { l10n } = useAppLocalization()

    const { values, setFieldValue } = useFormikContext<CreateOrEditShopFormValues>()

    const { data: allPaymentMethods = [] } = useApiQuery(paymentMethodsList, {
        queryName: ShopsQuery.PAYMENT_METHODS,
        dependencies: {
            merchantId,
            shopType: values.type,
        },
        select: selectShops,
    })

    return (
        <>
            <LocalizedStrict id="merchant-shop-form-payment-methods">
                <Typography variant="subtitle1" fontWeight={700}>
                    Available payment methods
                </Typography>
            </LocalizedStrict>
            {allPaymentMethods.map((option, index) => (
                <CustomCheckboxAccordion
                    key={index}
                    name={`paymentDetails.paymentMethods.${index}`}
                    label={l10n.getStringForEnum("purchases-payment-method", getPaymentMethodType(option.value), "")}
                    checked={isOptionSelected(values.paymentDetails.paymentMethods, option.value)}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        const { checked } = event.target
                        if (checked) {
                            // Add the option object to the array
                            setFieldValue("paymentDetails.paymentMethods", [
                                ...values.paymentDetails.paymentMethods,
                                option,
                            ])
                        } else {
                            // Remove the option object from the array based on value comparison
                            setFieldValue(
                                "paymentDetails.paymentMethods",
                                values.paymentDetails.paymentMethods.filter((item) => item.value !== option.value),
                            )
                        }
                    }}
                >
                    {/* TODO: change when the data will be the result of the request */}
                    <AccordionContent />
                </CustomCheckboxAccordion>
            ))}
        </>
    )
}
type Option = Readonly<{
    value: string
}>
const isOptionSelected = (selectedOptions: Option[], optionValue: string) => {
    return selectedOptions.some((option) => option.value === optionValue)
}
